import React from 'react'

export default function WhiteBoard({ children, className }) {
    return (
        <div className={`flex flex-col gap-8 bg-white dark:bg-black rounded-lg p-5 ${className}`} >
            {children}
        </div >
    )
}
